import styled from 'styled-components/macro';
import { Button } from '~/components';

export const MessageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ width }) => width || 100}%;
  min-width: 320px;
  display: flex;
  flex-direction: column;
  max-width: ${({ maxWidth }) => maxWidth || '100%'};
  background-color: ${({ theme }) => theme.white};
  padding: 20px;
`;

export const Message = styled.p`
  font-family: ${({ theme }) => theme.primaryFontMedium};
  font-size: ${({ theme }) => theme.h5}px;
  text-align: center;
`;

export const BackButton = styled(Button)`
  background-color: ${({ theme }) => theme.dark};
  padding: 5px;
  border-radius: 5px;
  width: 100px;
  margin-top: 10px;
  border-style: none;

  a {
    text-align: center;
    color: ${({ theme }) => theme.white};
    text-decoration: none;
  }
`;
